import { useEffect, useRef } from 'react';

type Input = {
    condition: boolean;
    cb: () => void;
    timeout: number;
};

export function useConditionalCallback({ condition, cb, timeout }: Input): void {
    const timeoutRef = useRef<NodeJS.Timeout | undefined | null>();
    useEffect(() => {
        if (condition) {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
            timeoutRef.current = setTimeout(cb, timeout);
        } else if (!condition && timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [cb, condition, timeoutRef, timeout]);
}
